// useAppLocation.js
import { useLocation } from 'react-router-dom';

export function useAppLocation() {
  return useLocation();
}
